import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import A0001Admin from '@/components/functions/A0001Admin/A0001AdminStore'
import D0101Demo from '@/components/functions/D0101Demo/D0101DemoStore'
import M0002Product from '@/components/functions/M0002Product/M0002ProductStore'
import M0005Frame from '@/components/functions/M0005Frame/M0005FrameStore'
import Purchase from '@/components/functions/Purchase/PurchaseStore'
import Top from '@/components/functions/Top/TopStore'
import Category from '@/components/functions/P0102Category/Categorystore'
import M0405FrameType from '@/components/functions/M0405FrameType/M0405FrameTypestore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.use(Vuex)
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    A0001Admin,
    D0101Demo,
    M0002Product,
    M0005Frame,
    Purchase,
    Top,
    Category,
    M0405FrameType
  }
})
